import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { HoldingsQueryKeys } from "modules/HoldingsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerID } from "models";

export type UpdateHoldingPayload = {
  id: number;
  name: string;
  dealer_ids: DealerID[];
};

export const useUpdateHoldingMutation = () =>
  useTypedMutation<UpdateHoldingPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/holdings/update", payload, ENV.holdingBaseURL);
    },
    onSuccess: payload => {
      const holdings = typedQueryClient.getQueryData(HoldingsQueryKeys.list);
      if (!holdings?.length) return;

      const holdingIdx = holdings.findIndex(holding => holding.id === payload.id);
      if (holdingIdx === -1) return;

      typedQueryClient.setQueryData(HoldingsQueryKeys.list, holdings.with(holdingIdx, { ...holdings[holdingIdx], ...payload }));
    }
  });
